var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCategoryOptions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 6,
    viewBox: "0 0 21 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.964 5.85C2.132 5.85 1.43 5.57267 0.858 5.018C0.286 4.46333 0 3.76133 0 2.912C0 2.04533 0.277333 1.34333 0.832 0.806C1.404 0.268667 2.11467 0 2.964 0C3.83067 0 4.54133 0.268667 5.096 0.806C5.65067 1.34333 5.928 2.04533 5.928 2.912C5.928 3.76133 5.642 4.46333 5.07 5.018C4.51533 5.57267 3.81333 5.85 2.964 5.85Z",
    fill: "#242946"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3273 5.85C9.49528 5.85 8.79328 5.57267 8.22128 5.018C7.64928 4.46333 7.36328 3.76133 7.36328 2.912C7.36328 2.04533 7.64061 1.34333 8.19528 0.806C8.76728 0.268667 9.47795 0 10.3273 0C11.1939 0 11.9046 0.268667 12.4593 0.806C13.0139 1.34333 13.2913 2.04533 13.2913 2.912C13.2913 3.76133 13.0053 4.46333 12.4333 5.018C11.8786 5.57267 11.1766 5.85 10.3273 5.85Z",
    fill: "#242946"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6906 5.85C16.8586 5.85 16.1566 5.57267 15.5846 5.018C15.0126 4.46333 14.7266 3.76133 14.7266 2.912C14.7266 2.04533 15.0039 1.34333 15.5586 0.806C16.1306 0.268667 16.8412 0 17.6906 0C18.5572 0 19.2679 0.268667 19.8226 0.806C20.3772 1.34333 20.6546 2.04533 20.6546 2.912C20.6546 3.76133 20.3686 4.46333 19.7966 5.018C19.2419 5.57267 18.5399 5.85 17.6906 5.85Z",
    fill: "#242946"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryOptions);
export default __webpack_public_path__ + "static/media/category-options.813c34894a132c8bc9bba2f40b70bcfa.svg";
export { ForwardRef as ReactComponent };